/**
 * @param {object} state
 * @param {object} board
 */
const addBoard = (state, board) => {
  const index = state.boards.length

  state.boards.splice(index, 1, board)
}

/**
 * @param {object} state
 * @param {number} boardId
 */
const deleteBoard = (state, boardId) => {
  const index = state.boards.findIndex(board => board.id === boardId)

  state.boards.splice(index, 1)
}

/**
 * @param {object} state
 * @param {object} payload
 */
const setBoards = (state, payload) => {
  state.boards = payload
}

/**
 * @param {object} state
 * @param {object} board
 */
const updateBoard = (state, board) => {
  const index = state.boards.findIndex(boardState => boardState.id === board.id)

  Object.assign(state.boards[index], board)
}

/**
 * @type {object}
 */
const mutations = {
  addBoard,
  deleteBoard,
  setBoards,
  updateBoard
}

export default mutations
